var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharepoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 28,
    height: 28,
    rx: 2,
    fill: "#51B1BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19.5502C21 20.4728 20.7721 21.2677 20.3162 21.9348C19.8675 22.6019 19.2194 23.1129 18.3718 23.4677C17.5313 23.8226 16.5271 24 15.359 24C14.7892 24 14.2443 23.9681 13.7244 23.9042C13.2044 23.8403 12.713 23.7481 12.25 23.6274C11.7942 23.4997 11.3775 23.3471 11 23.1697V20.7638C11.6339 21.0406 12.3426 21.2925 13.1261 21.5196C13.9095 21.7396 14.7073 21.8496 15.5192 21.8496C16.1816 21.8496 16.7301 21.7645 17.1645 21.5941C17.6061 21.4167 17.9338 21.1683 18.1474 20.849C18.3611 20.5225 18.4679 20.1428 18.4679 19.7099C18.4679 19.2486 18.3433 18.8583 18.094 18.5389C17.8447 18.2196 17.4672 17.9286 16.9615 17.666C16.463 17.3963 15.8362 17.1089 15.0812 16.8037C14.5684 16.5979 14.0769 16.3637 13.6068 16.1011C13.1439 15.8385 12.7308 15.5298 12.3675 15.175C12.0043 14.8201 11.7158 14.4014 11.5021 13.9188C11.2956 13.4291 11.1923 12.8543 11.1923 12.1943C11.1923 11.3143 11.4024 10.562 11.8226 9.93746C12.25 9.31293 12.8483 8.83389 13.6175 8.50033C14.3939 8.16678 15.2984 8 16.3312 8C17.1503 8 17.9195 8.08516 18.6389 8.25549C19.3654 8.42582 20.0776 8.66711 20.7756 8.97937L19.9637 11.0339C19.3226 10.7713 18.6994 10.562 18.094 10.4059C17.4957 10.2497 16.8832 10.1717 16.2564 10.1717C15.7151 10.1717 15.2557 10.2533 14.8782 10.4165C14.5007 10.5797 14.2123 10.8104 14.0128 11.1084C13.8205 11.3994 13.7244 11.7472 13.7244 12.1517C13.7244 12.6059 13.8348 12.9891 14.0556 13.3014C14.2835 13.6066 14.6325 13.8869 15.1026 14.1424C15.5798 14.3979 16.1923 14.6817 16.9402 14.994C17.802 15.3489 18.5321 15.7214 19.1303 16.1118C19.7358 16.5021 20.1987 16.9705 20.5192 17.517C20.8397 18.0563 21 18.7341 21 19.5502Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepoint);
export default __webpack_public_path__ + "static/media/Sharepoint.809f164d4708e533aeacd363b611d528.svg";
export { ForwardRef as ReactComponent };